export const SEND_UPGRADE_REQUEST_SUCCESS = `Upgrade request sent successfully.`;
export const GET_ALL_USERS_API_PAGE_VALUE = 1;
export const GET_ALL_USERS_API_LIMIT_VALUE = 0;
